import { render, staticRenderFns } from "./Entregapanel.vue?vue&type=template&id=0c892065"
import script from "./Entregapanel.vue?vue&type=script&lang=js"
export * from "./Entregapanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports